var exports = {
  "B": "suggestionButton__7LWTFU",
  "K": "icon__NQpI2U",
};

module.exports = exports;
